module.exports = __webpack_public_path__ + "img/download.f6429253.svg";